export const ONBOARDING_ROLE = {
  engineering: 'Engineering',
  management: 'Product Management',
  founder: 'Founder',
  leadership: 'Leadership',
  marketing: 'Marketing',
  sales: 'Sales',
  other: 'Other',
} as const
